"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var FilesPreviewView_1 = require("views/FilesPreviewView");
var connected_react_router_1 = require("connected-react-router");
var tenderActions = require("@caddigital/sok-reducers/lib/actions/bid/tender");
var translate_1 = require("utils/translate");
var Types = require("types");
var folderPath = [];
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)() || 'en';
    var sectionRoot = "".concat(ownProps.match.params.section, "Root");
    var sectionStatus = "".concat(ownProps.match.params.section, "Status");
    return {
        user: state.auth.current.user,
        preview: state.bid.tender.preview,
        tenderStatus: state.bid.tender.status,
        root: state.bid.tender.documents[sectionRoot],
        status: state.bid.tender.documents[sectionStatus],
        files: state.bid.tender.documents[ownProps.match.params.section],
        sortByOptions: tenderActions.sortByOptions,
        searchOptions: tenderActions.searchOptions,
        token: state.auth.current.token,
        filtering: tenderActions.searchOptions.filtering,
        selectedLanguage: selectedLanguage,
        filteredMetadataColumns: state.bid.tender.metaSchema.list,
        folderPath: folderPath,
        metadata: state.bid.tender.metaSchema
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchSection: function (folder, section) {
        return dispatch(tenderActions.fetchFilesRequest(folder.id, tenderActions.sortByOptions, tenderActions.searchOptions, undefined, section));
    },
    moveTo: function (url) { return dispatch((0, connected_react_router_1.push)(url)); },
    fetchRevisions: function (fileUUID) {
        return dispatch(tenderActions.RevisionActions.fetchRequest(fileUUID, 'COMPLETE'));
    },
    setPreviewRevision: function (revision) {
        return dispatch(tenderActions.PreviewActions.setPreviewRevision(revision));
    },
    convert: function (revision) {
        dispatch(tenderActions.PreviewActions.generatePreviewRequest(revision.uuid));
    },
    fetchFiles: function (folderId, sortByOptions, searchOptions) {
        /* ignore */
    },
    navigateTo: function (url, filtering) {
        dispatch((0, connected_react_router_1.push)(url));
    },
    moveToRevision: function (path, fileUUID, revisionUuid) {
        var splitted = path.split('/');
        dispatch((0, connected_react_router_1.push)(splitted.slice(0, splitted.length - 3).join('/') +
            "/".concat(fileUUID, "/revision/").concat(revisionUuid)));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var StatePropsWitness = Types.extractReturnType(exports.mapStateToProps);
var DispatchPropsWitness = Types.extractReturnType(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('showRevisionList', 'setShowRevisionList', false), (0, recompose_1.withState)('filteredAndSortedFiles', 'setFilteredAndSortedFiles', []), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        this.props.fetchRevisions(this.props.match.params.fileUUID);
        this.props.setFilteredAndSortedFiles(this.props.files);
        if (this.props.status === 'STANDBY' && this.props.root) {
            this.props.fetchSection(this.props.root, this.props.match.params.section);
        }
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        if (this.props.match.params.fileUUID !== prevProps.match.params.fileUUID) {
            this.props.fetchRevisions(this.props.match.params.fileUUID);
        }
        if (this.props.status === 'STANDBY' &&
            this.props.root &&
            this.props.tenderStatus !== prevProps.tenderStatus &&
            this.props.tenderStatus === 'FETCHED') {
            this.props.fetchSection(this.props.root, this.props.match.params.section);
        }
        if (this.props.match.params.revisionUuid !==
            prevProps.match.params.revisionUuid ||
            (this.props.preview.status !== prevProps.preview.status &&
                this.props.preview.status === 'FETCHED')) {
            var revision = this.props.preview.revisions.find(function (f) {
                return f.uuid === _this.props.match.params.revisionUuid.trim();
            });
            if (revision) {
                this.props.setPreviewRevision(revision);
            }
        }
        if (this.props.files !== prevProps.files) {
            this.props.setFilteredAndSortedFiles(this.props.files);
        }
    }
}), recompose_1.pure);
exports.default = enhance(FilesPreviewView_1.FilesPreviewViewPure);
